import { render, staticRenderFns } from "./DerbyList.vue?vue&type=template&id=1bec7b92&scoped=true&"
import script from "./DerbyList.vue?vue&type=script&lang=js&"
export * from "./DerbyList.vue?vue&type=script&lang=js&"
import style0 from "./DerbyList.vue?vue&type=style&index=0&id=1bec7b92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bec7b92",
  null
  
)

export default component.exports